import { makeStyles } from '@material-ui/core/styles';

export const useFormAnalyticsReportStyles = makeStyles(theme => ({
  formReport: {
    flexGrow: 1
  },
  reportFileName: {
    flex: 1
  }
}));
